import Marquee from "react-fast-marquee";

const ITEMS = [
  "GPS CHECK-INS",
  "SHIFT SCHEDULING",
  "PHOTO PROOF",
  "LIVE DASHBOARDS",
  "LEAD CAPTURE",
  "OFFLINE MODE",
  "TEAM CHAT",
  "PAYROLL EXPORT",
];

export const Ticker = () => {
  return (
    <div data-testid="ticker" className="border-y-2 border-paper bg-orange py-4 halftone-ink">
      <Marquee speed={40} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <span key={i} className="mx-6 inline-flex items-center gap-6">
            <span className="font-bebas text-3xl uppercase tracking-wide text-ink sm:text-4xl">{t}</span>
            <span className="font-bebas text-3xl text-ink sm:text-4xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
